import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import { useLoading } from '@/contextProviders/loadingProvider';
import { useFetchWithAuth } from '@/queries/useFetchWithAuth';

export const useDeleteQuery = <BodyData, ResponseData = BodyData>(
  url: string,
): {
  delete: (data: BodyData) => Promise<ResponseData | null>;
  errorMessage: string | null;
} => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const { setLoading } = useLoading();
  const { fetchWithAuth } = useFetchWithAuth();

  const deleteRequest = useCallback(
    async (data: BodyData) => {
      try {
        setLoading(true);
        const response = await fetchWithAuth(url, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        });
        const responseData = await response.json();
        setLoading(false);
        return responseData;
      } catch (error: unknown | Error) {
        if (error instanceof Error) {
          setErrorMessage(error.message);
          console.log(errorMessage);
          toast.error(errorMessage);
        } else {
          console.log(error);
        }
        setLoading(false);
        return null;
      }
    },
    [errorMessage, fetchWithAuth, setLoading, url],
  );

  return { delete: deleteRequest, errorMessage };
};
